<main class="main">
    <div class="sql-editor">
        <div class="editor-header">
            <h2>SQL Query Runner</h2>
            <span class="badge" *ngIf="!allowUpdate">SELECT only</span>
        </div>
        
        <div class="editor-area">
            <textarea [(ngModel)]="query" placeholder="SELECT * FROM dbo.MyTable WHERE ..." spellcheck="false"
                (keydown.control.enter)="run()"></textarea>
            <div class="editor-hint">Ctrl+Enter to run</div>
        </div>
        
        <div class="actions">
            <button class="btn-primary" (click)="run()" [disabled]="loading || !query.trim()">
                {{ loading ? 'Running…' : '▶ Run Query' }}
            </button>
            <button class="btn-secondary" (click)="clear()" [disabled]="loading">Clear</button>
            <label class="wrap-toggle" style="margin-top: 10px;">
                <input type="checkbox" [(ngModel)]="wrapText" />
                Wrap text
            </label>
            <button class="btn-primary" style="margin-left: auto;" (click)="exportToExcel(query)">
                ↓ Export to Excel
            </button> 
        </div>

        <!-- Error -->
        @if (error) {
        <div class="error-box">
            <strong>Error:</strong> {{ error }}
        </div>
        }
        <!-- Results -->
        @if (result) {
        <div class="results">

            <!-- Page size selector (global) -->
            <!-- <div class="page-size-bar">
                <label>Rows per page:</label>
                @for (size of pageSizeOptions; track size) {
                <button class="page-size-btn" [class.active]="pageSize === size" (click)="onPageSizeChange(size)">
                    {{ size }}
                </button>
                }
            </div> -->

            @for (table of result.Tables; track table; let i = $index) {
            <div class="result-block">

                <div class="result-meta">
                    <span>
                        Query {{ i + 1 }} —
                        Showing {{ getPaginatedRows(table, i).length }} of
                        {{ getFilteredRows(table).length }} rows
                        @if (getFilteredRows(table).length !== table.RowCount) {
                        <span class="filtered-note">(filtered from {{ table.RowCount }})</span>
                        }
                    </span>
                    <div class="result-meta-actions">
                        <!-- Wrap text checkbox -->
                        @if (table.Rows.length > 0)
                        {
                            <button class="btn-link" (click)="clearFilters()">Clear filters</button>
                        }

                    </div>
                </div>

                @if (table.Rows.length > 0) {
                <div class="col-12 table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                @for (col of table.Columns; track col) {
                                <th>{{ col }}</th>
                                }
                            </tr>
                            <tr class="filter-row">
                                @for (col of table.Columns; track col) {
                                <th>
                                    <div class="filter-box">

                                        <!-- Search input -->
                                        @if (!isValueless(col)) {
                                        <input type="text" class="filter-input" placeholder="Search"
                                            [value]="getFilter(col).value"
                                            (input)="onFilterValueChange(col, $any($event.target).value)" />
                                        }

                                        <!-- Filter icon button -->
                                        <button type="button" class="filter-btn" (click)="toggleFilterMenu(col)">
                                            <i class="fa fa-filter"></i>
                                        </button>

                                        @if (activeFilterColumn === col) {
                                        <div class="filter-menu">

                                            <select class="filter-operator" [value]="getFilter(col).operator"
                                                (change)="onOperatorChange(col, $any($event.target).value)">
                                                @for (op of filterOperators; track op.value) {
                                                <option [value]="op.value">{{ op.label }}</option>
                                                }
                                            </select>

                                        </div>
                                        }
                                    </div>
                                </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of getPaginatedRows(table, i); track $index) {
                            <tr>
                                @for (col of table.Columns; track col) {
                                <!-- <td [class.wrap]="wrapText">{{ row[col] ?? 'NULL' }}</td> -->
                                <td [class.wrap]="wrapText">
                                    @if (isXML(row[col])) {
                                    <a href="javascript:void(0)" class="xml-link" (click)="openXMLModal(row[col], col)"
                                        title="Click to view XML in browser">
                                        <i class="fa fa-file-code-o"></i> View XML
                                    </a>
                                    } @else {
                                    {{ getCellValue(row[col]) }}
                                    }
                                </td>
                                }
                            </tr>
                            } @empty {
                            <tr>
                                <td [attr.colspan]="table.Columns.length" class="no-match">
                                    No rows match the current filters.
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Bottom bar -->
                <div class="table-footer">

                    <!-- Left: Rows per page dropdown -->
                    <div class="rows-per-page">
                        <select [id]="'pageSize_' + i" [value]="pageSize"
                            (change)="onPageSizeChange(+$any($event.target).value)">
                            @for (size of pageSizeOptions; track size) {
                            <option [value]="size">{{ size }}</option>
                            }
                        </select>
                        <label for="pageSize_{{i}}">Items per page</label>
                    </div>

                    <!-- Right: Page info + navigation -->
                    <div class="paginator">
                        <span class="page-info">
                            Page {{ getCurrentPage(i) }} of {{ getTotalPages(table, i) }}
                        </span>

                        <button class="page-btn" title="First" [disabled]="getCurrentPage(i) === 1"
                            (click)="goToPage(i, 1, getTotalPages(table, i))">«</button>

                        <button class="page-btn" title="Previous" [disabled]="getCurrentPage(i) === 1"
                            (click)="goToPage(i, getCurrentPage(i) - 1, getTotalPages(table, i))">‹</button>

                        @for (page of getPageNumbers(table, i); track page) {
                        @if (page === -1) {
                        <span class="ellipsis">…</span>
                        } @else {
                        <button class="page-btn" [class.active]="getCurrentPage(i) === page"
                            (click)="goToPage(i, page, getTotalPages(table, i))">
                            {{ page }}
                        </button>
                        }
                        }

                        <button class="page-btn" title="Next" [disabled]="getCurrentPage(i) === getTotalPages(table, i)"
                            (click)="goToPage(i, getCurrentPage(i) + 1, getTotalPages(table, i))">›</button>

                        <button class="page-btn" title="Last" [disabled]="getCurrentPage(i) === getTotalPages(table, i)"
                            (click)="goToPage(i, getTotalPages(table, i), getTotalPages(table, i))">»</button>
                    </div>

                </div>

                } @else {
                <p class="empty">Query {{ i + 1 }} returned no rows.</p>
                }

            </div>
            }
        </div>
        }
    </div>
    <app-loader [showLoader]="showLoader"></app-loader>
</main>